import * as React from "react";

import { IAgent } from "store/entities/agents";

import LegacyAgentSignature from "./legacy/AgentSignature";
import RichTextAgentSignature from "./richtext/AgentSignature";

interface IOldIEDocument extends Document {
  documentMode?: number;
}

const AgentSignature: React.FC<{
  canChange: boolean;
  agentID?: IAgent["id"];
  overflowRef?: HTMLDivElement;
}> = props => {
  const isInternetExplorer = !!(document as IOldIEDocument).documentMode;
  const isEdge = /Edge/.test(window.navigator.userAgent);
  const isAndroidMobile = /Android/.test(window.navigator.userAgent);

  const isCompatibleBrowser = !(isInternetExplorer || isEdge || isAndroidMobile);

  return isCompatibleBrowser ? <RichTextAgentSignature {...props} /> : <LegacyAgentSignature {...props} />;
};

export default AgentSignature;
